import { AxiosError } from 'axios';
import { POST_FORGOT_PASSWORD_LINK_GENERATION_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GenerateResetRequest {
  username: string;
  dateOfBirth: string;
}

export interface GenerateResetResponse {
  email: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: GenerateResetResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostForgotPassword = ({ onSuccess, onError }: Input) => {
  const postForgotPassword = async (data: GenerateResetRequest) => {
    const res = await axiosClient.post<GenerateResetResponse>(
      POST_FORGOT_PASSWORD_LINK_GENERATION_URL,
      data
    );

    return res.data;
  };

  return useCustomMutation(
    postForgotPassword,
    {
      onSuccess,
      onError,
    },
    false,
    false
  );
};
